import React from 'react';
import Layout from '../components/layout';
import Ogp from '../components/ogp';
import VisualImage from '../components/visualImage';

const StatementIndex: React.FC<{}> = () => {
  const picUrl =
    'https://static.juggling-mstdn.net/media_attachments/files/000/000/021/original/980520db79ed6a3e.jpg';
  return (
    <Layout>
      <Ogp isRoot={false} />
      <div style={{ background: '#fff' }}>
        <div>
          <VisualImage
            titleData={['Statement']}
            picUrl={picUrl}
            type="primary"
          />
        </div>
        <div className="wrapper">
          <h2 className="section-headline">Statement</h2>
          <div>
            新型感染症の世界的大流行により社会は危機的な状況にあります。
            ジャグリングシーンも同様であり多くのイベント、大会が中止に陥り、今後も開始する見込みが立ちづらくなっています。
            このようなジャグリングを「する、見る、考える」ことの基盤が揺らぐ状況の中で、私たちはジャグリングを続けていくことができるのでしょうか？
            可能ならばそれはいかなる形なのでしょうか？
            <br />
            その状況に向き合うべくピントクルは「これからのジャグリング」を模索する発表会「ぴんとくるくる浄土」を開催します。
            大会やイベントの中止によって陽の目をみないジャグリング、これまでの日常の中で当たり前に紡がれてきたジャグリング、そして、これからのジャグリング。
            それらを見る者を会場に呼び込まない「来場不可」という形式をとりつつ、テキストや動画などの情報を用いて記録し発信することで、
            「ジャグリングを通して集まる」ことの新しい形を目指します。
          </div>
          <div
            style={{
              textAlign: 'right',
              paddingTop: '20px',
              fontSize: '0.9em',
            }}
          >
            2020.04.11 Juggling Unit ピントクル 中西みみず
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default StatementIndex;
